import React from 'react';
import './FloatingChatButton.css';

// Shell only (feature flag `floating_chat`, default OFF). Chat left the main nav
// on 2026-07-18; when this flag is turned on, this button becomes the global
// entry point to the assistant. No panel/behavior implemented yet on purpose —
// wire onClick to open the chat surface when this ships for real.
export default function FloatingChatButton({ onClick }) {
  return (
    <button
      type="button"
      className="floating-chat-button"
      onClick={onClick}
      aria-label="Open chat"
    >
      <svg width="22" height="22" viewBox="0 0 20 20" fill="none">
        <path d="M17 13c0 .6-.4 1-1 1h-10l-4 4V4c0-.6.4-1 1-1h13c.6 0 1 .4 1 1v9z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    </button>
  );
}
